module.exports = __webpack_public_path__ + "static/img/about03.0651c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about03.png
// module id = BFNF
// module chunks = 1